export default {plugin:{connector:{ui:{connect:'Connect with {{ auth_name }}',remove:'Remove {{ auth_name }}'}}}};